import { Container, SimpleGrid, Button, Group, Title, FileInput, Paper, Stack, Divider, Grid, Stepper, Center, Progress } from '@mantine/core';
import { AppContext } from '../../context/context';
import { useContext, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import classes from './Home.module.css';
import TableAlerts from '../CustomComponents/TableAlerts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
//for get the current mont
const month = ["Enero", "Febrero", "MArzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];





const Home = () => {
  const icon = <FontAwesomeIcon icon={faFileExcel} size={12} stroke={1.5} />;
  const appcontext = useContext(AppContext);

  const { user, getAccessTokenSilently } = useAuth0();
  const [currentMonth, setMont] = useState('');

  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [state, setState] = useState({
    active: 0,
    status: "Esperando archivo",
    loading: false,
    error: false,
  });
  const [proceso, setProceso] = useState(null);

  function patternToRegex(pattern) {
    // STEP 1: Escape regex special chars EXCEPT: *, [, ]
    let regex = pattern.replace(/[-\/\\^$+?.()|{}]/g, '\\$&');

    // STEP 2: Replace date placeholders BEFORE touching *
    regex = regex.replace(/\[dd_MMM_yyyy\]/g, '(\\d{2}_[A-Za-z]{3}_\\d{4})');

    regex = regex.replace(/\[yyyyMMdd\]/g, '(\\d{8})(\\d{0,6})?');

    regex = regex.replace(/\[ddMMyy\]/g, '(\\d{6})(\\d{0,6})?');

    // STEP 3: Now safely handle "*"
    regex = regex.replace(/\*/g, '.*');

    // STEP 4: Wrap as case-insensitive regex
    return new RegExp(`^${regex}$`, "i");
  }

  function normalizeDate(baseDate, timestamp) {
    let year, month, day, hours = "00", mins = "00", secs = "00";

    // ---- 1: dd_MMM_yyyy ----
    if (/^\d{2}_[A-Za-z]{3}_\d{4}$/.test(baseDate)) {
      const [dd, MMM, yyyy] = baseDate.split("_");

      // Convert month to number
      const months = {
        JAN: "01", FEB: "02", MAR: "03", APR: "04",
        MAY: "05", JUN: "06", JUL: "07", AUG: "08",
        SEP: "09", OCT: "10", NOV: "11", DEC: "12"
      };

      day = dd;
      month = months[MMM.toUpperCase()];
      year = yyyy;
    }

    // ---- 2: yyyyMMdd ----
    else if (/^\d{8}$/.test(baseDate)) {
      year = baseDate.slice(0, 4);
      month = baseDate.slice(4, 6);
      day = baseDate.slice(6, 8);
    }

    // ---- 3: ddMMyy ----
    else if (/^\d{6}$/.test(baseDate)) {
      day = baseDate.slice(0, 2);
      month = baseDate.slice(2, 4);
      year = "20" + baseDate.slice(4, 6); // assume 20xx
    }

    // ---- Handle timestamp (optional) ----
    if (timestamp) {
      if (timestamp.length >= 2) hours = timestamp.slice(0, 2);
      if (timestamp.length >= 4) mins = timestamp.slice(2, 4);
      if (timestamp.length >= 6) secs = timestamp.slice(4, 6);
    }

    // ---- Return final format (customizable) ----
    return `${year}-${month}-${day} ${hours}:${mins}:${secs}`;
  }


  function validateFileName(fileName, patterns) {
    for (const p of patterns) {
      const regex = patternToRegex(p.Name);
      const match = fileName.match(regex);

      if (match) {
        const baseDate = match[1];
        const timestamp = match[2] || "";

        return {
          valid: true,
          pattern: p.Name,
          baseDate,
          timestamp,
          normalizedDate: normalizeDate(baseDate, timestamp)
        };
      }
    }

    return { valid: false };
  }


  const uploadFile = async () => {
    if (!file) return alert("Seleccione un archivo");

    try {

      setState((s) => ({ ...s, active: 1, loading: true, status: "Validando nombre y fecha del archivo..." }));
      // 1️⃣ Get presigned URL from API
      const filesName = await fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/utils/getFilesName",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
            "Content-Type": "application/json",
          },
        }
      );
      var result = await filesName.json();
      const validation = validateFileName(file.name, result.rows);
      console.log(result.rows, validation);

      if (validation.valid) {
        setState((s) => ({ ...s, active: 1, loading: true, status: "Solicitando URL..." }));
        // 1️⃣ Get presigned URL from API
        const res = await fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/utils/getS3PresignedURL?filename=uploads/" + file.name,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
              "Content-Type": "application/json",
            },
          }
        );

        const { url } = await res.json();

        setState((s) => ({ ...s, status: "Subiendo archivo a S3..." }));

        // 2️⃣ Upload the file to S3
        await axios.put(url, file, {
          headers: {
            "Content-Type": file.type
          },
          onUploadProgress: (event) => {
            if (event.total) {
              const percent = Math.round((event.loaded / event.total) * 100);
              setProgress(percent);

              // move stepper when upload finishes
              if (percent === 100) {
                setState((s) => ({ ...s, active: 2, status: "Archivo subido!" }));
              }
            }
          },
        });

        setState((s) => ({ ...s, active: 2, status: "Archivo subido. Procesando..." }));

        if (validation.pattern.includes('RAPID_BILLING_SEGMENT_FILE')) {
          let date = validation.normalizedDate.split(' ');
          const payload = {
            fileDate: date[0],
            filename: file.name,
            bucket: process.env.REACT_APP_BUCKETNAME,
            key: "uploads/" + file.name
          };
          console.log(payload);
          const { data } = await axios.post(process.env.REACT_APP_API_ENP +
            "/sscn-back/api/insert/insertRapid",
            payload,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                "Content-Type": "application/json"
              }
            }
          );

          // 🧩 Step 2: Poll the status every 30 seconds
          const interval = setInterval(async () => {
            try {

              const { data } = await axios.get(process.env.REACT_APP_API_ENP + "/sscn-back/api/insert/getInsertStatus",
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                  },
                  params: {
                    filename: 'rapid',
                  }
                }
              );
              console.log('interval data', data);
              if (data.ESTATUS == 1) {
                setState((s) => ({
                  ...s,
                  active: 2,
                  loading: true,
                  error: false,
                  status: data.DESCRIPCION,
                }));
              }

              if (data.ESTATUS == 0) {
                setState((s) => ({
                  ...s,
                  active: 4,
                  loading: false,
                  error: false,
                  status: "Archivo cargado",
                }));
                clearInterval(interval);
              }

              if (data.ESTATUS == 2) {
                setState((s) => ({
                  ...s,
                  active: 3,
                  loading: false,
                  error: true,
                  status: data.DESCRIPCION,
                }));
                clearInterval(interval);
              }

            } catch (pollErr) {
              setState((s) => ({
                ...s,
                active: s.active + 1,
                loading: false,
                error: true,
                status: pollErr,
              }));
            }
          }, 5_000);

        }else if (validation.pattern.includes('XXGAM___AR_Reporte_de_Facturas')) {
          let date = validation.normalizedDate.split(' ');
          const payload = {
            fileDate: date[0],
            filename: file.name,
            bucket: process.env.REACT_APP_BUCKETNAME,
            key: "uploads/" + file.name
          };
          console.log(payload);
          const { data } = await axios.post(process.env.REACT_APP_API_ENP +
            "/sscn-back/api/insert/insertOracle",
            payload,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                "Content-Type": "application/json"
              }
            }
          );

          // 🧩 Step 2: Poll the status every 30 seconds
          const interval = setInterval(async () => {
            try {

              const { data } = await axios.get(process.env.REACT_APP_API_ENP + "/sscn-back/api/insert/getInsertStatus",
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                  },
                  params: {
                    filename: 'Oracle',
                  }
                }
              );
              console.log('interval data', data);
              if (data.ESTATUS == 1) {
                setState((s) => ({
                  ...s,
                  active: 2,
                  loading: true,
                  error: false,
                  status: data.DESCRIPCION,
                }));
              }

              if (data.ESTATUS == 0) {
                setState((s) => ({
                  ...s,
                  active: 4,
                  loading: false,
                  error: false,
                  status: "Archivo cargado",
                }));
                clearInterval(interval);
              }

              if (data.ESTATUS == 2) {
                setState((s) => ({
                  ...s,
                  active: 3,
                  loading: false,
                  error: true,
                  status: data.DESCRIPCION,
                }));
                clearInterval(interval);
              }

            } catch (pollErr) {
              setState((s) => ({
                ...s,
                active: s.active + 1,
                loading: false,
                error: true,
                status: pollErr,
              }));
            }
          }, 5_000);

        }else if (validation.pattern.includes('KPI_SVD-')) {
          let date = validation.normalizedDate.split(' ');
          const payload = {
            fileDate: date[0],
            filename: file.name,
            bucket: process.env.REACT_APP_BUCKETNAME,
            key: "uploads/" + file.name
          };
          console.log(payload);
          const { data } = await axios.post(process.env.REACT_APP_API_ENP +
            "/sscn-back/api/insert/insertSky",
            payload,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                "Content-Type": "application/json"
              }
            }
          );

          // 🧩 Step 2: Poll the status every 30 seconds
          const interval = setInterval(async () => {
            try {

              const { data } = await axios.get(process.env.REACT_APP_API_ENP + "/sscn-back/api/insert/getInsertStatus",
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                  },
                  params: {
                    filename: 'SkyChain',
                  }
                }
              );
              console.log('interval data', data);
              if (data.ESTATUS == 1) {
                setState((s) => ({
                  ...s,
                  active: 2,
                  loading: true,
                  error: false,
                  status: data.DESCRIPCION,
                }));
              }

              if (data.ESTATUS == 0) {
                setState((s) => ({
                  ...s,
                  active: 4,
                  loading: false,
                  error: false,
                  status: "Archivo cargado",
                }));
                clearInterval(interval);
              }

              if (data.ESTATUS == 2) {
                setState((s) => ({
                  ...s,
                  active: 3,
                  loading: false,
                  error: true,
                  status: data.DESCRIPCION,
                }));
                clearInterval(interval);
              }

            } catch (pollErr) {
              setState((s) => ({
                ...s,
                active: s.active + 1,
                loading: false,
                error: true,
                status: pollErr,
              }));
            }
          }, 5_000);

        }else if (validation.pattern.includes('Tipos de Cambio')) {
          let date = validation.normalizedDate.split(' ');
          const payload = {            
            filename: file.name,
            bucket: process.env.REACT_APP_BUCKETNAME,
            key: "uploads/" + file.name
          };
          console.log(payload);
          const { data } = await axios.post(process.env.REACT_APP_API_ENP +
            "/sscn-back/api/insert/insertExchangeRate",
            payload,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                "Content-Type": "application/json"
              }
            }
          );

          // 🧩 Step 2: Poll the status every 30 seconds
          const interval = setInterval(async () => {
            try {

              const { data } = await axios.get(process.env.REACT_APP_API_ENP + "/sscn-back/api/insert/getInsertStatus",
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                  },
                  params: {
                    filename: 'ExcangeRate',
                  }
                }
              );
              console.log('interval data', data);
              if (data.ESTATUS == 1) {
                setState((s) => ({
                  ...s,
                  active: 2,
                  loading: true,
                  error: false,
                  status: data.DESCRIPCION,
                }));
              }

              if (data.ESTATUS == 0) {
                setState((s) => ({
                  ...s,
                  active: 4,
                  loading: false,
                  error: false,
                  status: "Archivo cargado",
                }));
                clearInterval(interval);
              }

              if (data.ESTATUS == 2) {
                setState((s) => ({
                  ...s,
                  active: 3,
                  loading: false,
                  error: true,
                  status: data.DESCRIPCION,
                }));
                clearInterval(interval);
              }

            } catch (pollErr) {
              setState((s) => ({
                ...s,
                active: s.active + 1,
                loading: false,
                error: true,
                status: pollErr,
              }));
            }
          }, 5_000);

        }else if (validation.pattern.includes('GEN5928_')) {
          let date = validation.normalizedDate.split(' ');
          const payload = {            
            fileDate: date[0],
            filename: file.name,
            bucket: process.env.REACT_APP_BUCKETNAME,
            key: "uploads/" + file.name
          };
          console.log(payload);
          const { data } = await axios.post(process.env.REACT_APP_API_ENP +
            "/sscn-back/api/insert/insertGen",
            payload,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                "Content-Type": "application/json"
              }
            }
          );

          // 🧩 Step 2: Poll the status every 30 seconds
          const interval = setInterval(async () => {
            try {

              const { data } = await axios.get(process.env.REACT_APP_API_ENP + "/sscn-back/api/insert/getInsertStatus",
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                  },
                  params: {
                    filename: 'GEN',
                  }
                }
              );
              console.log('interval data', data);
              if (data.ESTATUS == 1) {
                setState((s) => ({
                  ...s,
                  active: 2,
                  loading: true,
                  error: false,
                  status: data.DESCRIPCION,
                }));
              }

              if (data.ESTATUS == 0) {
                setState((s) => ({
                  ...s,
                  active: 4,
                  loading: false,
                  error: false,
                  status: "Archivo cargado",
                }));
                clearInterval(interval);
              }

              if (data.ESTATUS == 2) {
                setState((s) => ({
                  ...s,
                  active: 3,
                  loading: false,
                  error: true,
                  status: data.DESCRIPCION,
                }));
                clearInterval(interval);
              }

            } catch (pollErr) {
              setState((s) => ({
                ...s,
                active: s.active + 1,
                loading: false,
                error: true,
                status: pollErr,
              }));
            }
          }, 5_000);

        }





      } else {
        setState((s) => ({
          ...s,
          active: s.active + 1,
          loading: false,
          error: true,
          status: "Nombre del archivo invalido",
        }));
      }
    } catch (err) {
      console.error("entra error", err);
      setState((s) => ({
        ...s,
        active: s.active + 1,
        loading: false,
        error: true,
        status: "Ocurrió un error",
      }));
    }
  };

  useEffect(() => {
    appcontext.setCurrentUser('');
    const fetchAccessToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        sessionStorage.setItem("token", token)
        sessionStorage.setItem("user", user.nickname)
        //console.log(token);
      } catch (error) {
        console.error("Error getting access token:");
      }
    };
    fetchAccessToken();

    //for get current month
    setMont(month[new Date().getMonth()])
  }, []);

  const [value, setValue] = useState(null);

  return (
    <>
      <Container
        fluid
        p="md"
        style={{
          flex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          marginRight: '20px'
        }}
      >
        <Title order={1} style={{ marginBottom: 20 }}>Alertas {currentMonth}</Title>

        <SimpleGrid cols={{ base: 1, xs: 4 }} style={{ flex: 1 }} spacing="md" marginBottom="md">
          <TableAlerts heigth={500} />
        </SimpleGrid>

        <SimpleGrid cols={{ base: 1, xs: 4 }} style={{ flex: 1, marginTop: 20 }} spacing="md">
          <div style={{ gridColumn: '1 / -1' }}>
            <Stack spacing="md">
              <Paper shadow="xl" radius="xl" withBorder p="xl">
                <FileInput
                  label="Subir archivo"
                  description="Solo se aceptan archivos xls, xlsx, csv y DLT"
                  value={file}
                  accept=".csv,.xls,.xlsx,.DLT"
                  clearable
                  leftSection={icon}
                  onChange={setFile}
                />

                <Group justify="center" mt="md">
                  <Button variant="outline" color="rgba(2, 12, 65, 1)" onClick={uploadFile}>Subir archivos</Button>
                </Group>

                <Divider my="md" />
                <Grid justify="center" align="center">
                  <Grid.Col span={10}>
                    {/* ---- Stepper ---- */}
                    <Stepper active={state.active} allowNextStepsSelect={false}>
                      <Stepper.Step label="Inicio" description="Selecciona archivo" />
                      <Stepper.Step
                        label="Subiendo"
                        description="Subiendo a S3"
                        loading={state.active === 1 && state.loading}
                        completedIcon={state.error && state.active === 2 ? <FontAwesomeIcon icon={faCircleXmark} /> : undefined}
                        color={state.error && state.active === 2 ? 'red' : undefined}>
                        <Progress value={progress} size="lg" animated color="rgba(2, 12, 65, 1)" />
                      </Stepper.Step>

                      <Stepper.Step label="Procesando" description="Insertando BD"
                        loading={state.active === 2 && state.loading}
                        completedIcon={state.error && state.active === 3 ? <FontAwesomeIcon icon={faCircleXmark} /> : undefined}
                        color={state.error && state.active === 3 ? 'red' : undefined}
                      />
                      <Stepper.Step label="Listo" description="Todo completado" />
                    </Stepper>

                    {/* Status */}
                    <Center mt="lg">
                      <p>Status: {state.status}</p>
                    </Center>
                  </Grid.Col>
                </Grid>
              </Paper>
            </Stack>
          </div>
        </SimpleGrid>
      </Container >
    </>

  );

}

export default Home;